import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Slides from '@ifeng/ui_pc_slides';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import { getMcmsSwiper } from '../../../../../services/api';
import Chip from 'Chip';
import { handleAd } from '../../../../../utils/handleAd';

class BannerPic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        swiperData: PropTypes.object,
        curCity: PropTypes.object,
    };
    state = {
        mcmsSwiperData: PropTypes.string,
    };
    ref = React.createRef();
    async componentDidMount() {
        try {
            const mcmsSwiperData = await getMcmsSwiper(
                this.props.curCity && this.props.curCity.citypinyin ? this.props.curCity.citypinyin : 'beijing',
            );

            this.setState({
                mcmsSwiperData,
            });
            const callbackFn = await handleAd(this.props.swiperData.ad.swiperCar01Ad);
            const callbackFn2 = await handleAd(this.props.swiperData.ad.swiperCar02Ad);
            const callbackFn3 = await handleAd(this.props.swiperData.ad.swiperCar03Ad);

            callbackFn(this.ref.current, this.props.swiperData.ad.swiperCar01Ad.data);
            callbackFn2(this.ref.current, this.props.swiperData.ad.swiperCar02Ad.data);
            callbackFn3(this.ref.current, this.props.swiperData.ad.swiperCar03Ad.data);
        } catch (e) {
            console.error(e);
        }
    }

    // 渲染导航

    swiperView(list = []) {}

    sliderTmpl = (item, isClone, index) => {
        const { swiperData } = this.props;

        if (index === 1) {
            return (
                <div>
                    <Chip
                        id="160163"
                        type="static"
                        title="首页焦点图第一帧"
                        groupName="焦点图"
                        content={swiperData.swiperFirst}>
                        <div className={styles.content} ref="swiperFirst">
                            <div dangerouslySetInnerHTML={{ __html: swiperData.swiperFirst }} />
                        </div>
                    </Chip>
                </div>
            );
        } else if (index === 2) {
            return (
                <div>
                    <Chip
                        id="130164"
                        type="static"
                        title="首页焦点图第二帧"
                        groupName="焦点图"
                        content={swiperData.swiperSecond}
                        ref="swiperSecond">
                        <div className={styles.content}>
                            <div dangerouslySetInnerHTML={{ __html: swiperData.swiperSecond }} />
                        </div>
                    </Chip>
                </div>
            );
        } else if (index === 3) {
            return (
                <div>
                    <Chip
                        id="190163"
                        type="static"
                        title="首页焦点图第三帧"
                        groupName="焦点图"
                        content={swiperData.swiperThird}>
                        <div className={styles.content} ref="swiperThird">
                            <div dangerouslySetInnerHTML={{ __html: swiperData.swiperThird }} />
                        </div>
                    </Chip>
                </div>
            );
        } else {
            return (
                // <div >c cc</div>
                <div style={{ position: 'relative' }}>
                    <div dangerouslySetInnerHTML={{ __html: this.state.mcmsSwiperData }} />
                </div>
            );
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { content, swiperData, curCity } = this.props;

        const config = {
            arrows: false,
            autoplay: false,
            direction: 'forward',
            axis: 'horizonta',
            sliderTmpl: this.sliderTmpl,
            dotStyle: styles.dot_style,
            dotCurrentStyle: styles.current,
        };

        return (
            <div className={styles.bannerPic} ref={this.ref}>
                <Slides content={content} config={config} />
            </div>
        );
    }
}

export default errorBoundary(BannerPic);
